
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsMatTypeDialog extends Serenity.EntityDialog<CsMatTypeRow, any> {
        protected getFormKey() { return CsMatTypeForm.formKey; }
        protected getIdProperty() { return CsMatTypeRow.idProperty; }
        protected getLocalTextPrefix() { return CsMatTypeRow.localTextPrefix; }
        protected getNameProperty() { return CsMatTypeRow.nameProperty; }
        protected getService() { return CsMatTypeService.baseUrl; }
        protected getDeletePermission() { return CsMatTypeRow.deletePermission; }
        protected getInsertPermission() { return CsMatTypeRow.insertPermission; }
        protected getUpdatePermission() { return CsMatTypeRow.updatePermission; }

        protected form = new CsMatTypeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Mattypeid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.MatTypeId == this.entity.MatTypeId);
            console.log(Mattypeid);
            if(Mattypeid != null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.MatTypeId == this.entity.MatTypeId);            
            console.log(Plucheck);
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }

       
    }
}